// import 'stop-runaway-react-effects/hijack';
import './style/global.css';
import '@reach/dialog/styles.css';
import '@reach/tooltip/styles.css';
import './style/dialog.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import {library} from '@fortawesome/fontawesome-svg-core';
import {
  faPlus,
  faTrashAlt,
  faEdit,
  faRedo,
  faTimes,
  faExclamationTriangle,
  faDownload,
} from '@fortawesome/pro-light-svg-icons';
library.add(
  faPlus,
  faTrashAlt,
  faEdit,
  faRedo,
  faTimes,
  faExclamationTriangle,
  faDownload,
);
